import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatInput } from '@angular/material/input'
import { ServiceSpecificationService } from '../../../core/services/service/service-specification/service-specification.service'
import { ServiceTypeService } from '../../../core/services/service/service-type/service-type.service'
import { MatOption } from '@angular/material/core'
import { MatSelectModule } from '@angular/material/select'
import { MatSlideToggle } from '@angular/material/slide-toggle'
import { CurrencyInputDirective } from '../../../shared/directives/currencyInput'
import { IntegerInputDirective } from '../../../shared/directives/IntegerInput'
import { convertCurrency } from '../../../shared/utils/utils'

@Component({
  selector: 'service-specification-edit',
  imports: [
    MatButton,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatIcon,
    MatFormField,
    MatInput,
    MatLabel,
    MatOption,
    MatSelectModule,
    MatSlideToggle,
    CurrencyInputDirective,
    IntegerInputDirective,
  ],
  templateUrl: './service-specification-edit.component.html',
  styleUrl: './service-specification-edit.component.scss',
  providers: [ServiceSpecificationService],
  standalone: true,
})
export class ServiceSpecificationEditComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private serviceSpecificationService: ServiceSpecificationService,
    private serviceTypeService: ServiceTypeService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<ServiceSpecificationEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.itemEdit = data
  }

  @Output() responseEdit = new EventEmitter()

  itemEdit: any = {}
  form: FormGroup = new FormGroup({})
  loading = false
  listType: any[] = []

  ngOnInit(): void {
    this.createForm()
    this.listTypeService()
  }

  listTypeService() {
    this.serviceTypeService.listServiceType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listType = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  updateItem() {
    this.loading = true
    const model = this.createModel()
    this.serviceSpecificationService.editServiceSpecification(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseEdit.emit(true)
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        this.form.reset()
      },
    })
  }

  close() {
    this.dialogRef.close()
  }

  createModel() {
    let km = this.form.get('km')!.value
    let hour = this.form.get('hour')!.value
    if (km) {
      km = convertCurrency(km)
    } else {
      km = null
    }
    if (hour) {
      hour = parseInt(hour)
    } else {
      hour = null
    }

    return {
      id: this.itemEdit.id,
      descricao: this.form.controls['description'].value,
      tipoServicoId: this.form.controls['typeService'].value,
      exigeVeiculo: this.form.get('vehicle')!.value ? 'S' : 'N',
      km: km,
      hora: hour,
    }
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      code: [this.itemEdit.id, [Validators.required]],
      description: [this.itemEdit.descricao, [Validators.required]],
      typeService: [this.itemEdit.tipoServicoId, [Validators.required]],
      vehicle: [this.itemEdit.exigeVeiculo.toLowerCase() == 's' ? true : false],
      km: [
        typeof this.itemEdit.km == 'number'
          ? convertCurrency(this.itemEdit.km)
          : ``,
      ],
      hour: [this.itemEdit.hora ?? ``],
    })
    this.form.get('code')?.disable()
  }
}
